import { z } from 'zod';
import { MetaSchema } from './meta';

export const ComponentCO2LinkCreateSchema = z.object({
	co2: z.object({
		self: z.string().startsWith('/mdm/apps/one/stores/'),
	}),
	description: z.string(),
	name: z.string().min(1).max(55),
});

export const ComponentCO2LinkSchema = z.object({
	...ComponentCO2LinkCreateSchema.shape,
	meta: MetaSchema,
	self: z.string().startsWith('/mdm/apps/one/stores/'),
});

export const ComponentCO2LinkResponseSchema = z.object({
	items: z.array(ComponentCO2LinkSchema),
	self: z.string().startsWith('/mdm/apps/one/stores/'),
	total: z.int().min(0),
});

export type IComponentCO2LinkCreateSchema = z.infer<typeof ComponentCO2LinkCreateSchema>;
export type IComponentCO2LinkResponseSchema = z.infer<typeof ComponentCO2LinkResponseSchema>;
export type IComponentCO2LinkSchema = z.infer<typeof ComponentCO2LinkSchema>;
